import "core-js/modules/es.array.push.js";
import ChartCard from '../../../components/card/ChartCard';
import MiniArea from '../../../components/chart/MiniArea';
import MiniBar from '../../../components/chart/MiniBar';
import MiniProgress from '../../../components/chart/MiniProgress';
import Bar from '../../../components/chart/Bar';
import RankingList from '../../../components/chart/RankingList';
import HotSearch from './HotSearch';
import SalesData from './SalesData';
import Trend from '../../../components/chart/Trend';
var rankList = [];
for (var i = 0; i < 8; i++) {
  rankList.push({
    name: '桃源村' + i + '号店',
    total: 1234.56 - i * 100
  });
}
export default {
  name: 'Analysis',
  i18n: require('./i18n'),
  data: function data() {
    return {
      rankList: rankList,
      loading: true
    };
  },
  created: function created() {
    var _this = this;
    setTimeout(function () {
      return _this.loading = !_this.loading;
    }, 1000);
  },
  components: {
    Trend: Trend,
    SalesData: SalesData,
    HotSearch: HotSearch,
    RankingList: RankingList,
    Bar: Bar,
    MiniProgress: MiniProgress,
    MiniBar: MiniBar,
    MiniArea: MiniArea,
    ChartCard: ChartCard
  }
};